import React from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  Button,
  Row,
  Col
} from 'react-bootstrap';

const JNCancellationOpts = (props) => {
  const {
    show,
    onHide,
    handleClickKeepCurrentData,
    handleClickResetData
  } = props;

  return (
    <Modal
      show={show}
      onHide={onHide}
      backdrop='static'
      >
      <Modal.Header
        bsClass='modal-header success'
        closeButton
        >
        <Modal.Title>Cancel Job Nimbus Integration</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Choose one of the following options : </p>
        <hr className='dotted short' />
        <ul>
          <li>
            <h4>Keep Current Data</h4>
            <p>
              This option will not change of your current data; any changes you've made since you integrated
              your Hail Trace account with your Job Nimbus account will be in tact. The only differece will be
              that changes made to your Hail Trace clients will not be made to your Job Nimbus contacts, and
              vice versa.
            </p>
          </li>
          <li>
            <h4>Restor Pre-Integration Data</h4>
            <p>
              This will reset your Hail Trace client data to the exact state it was in prior to integrating with
              your Job Nimbus account. We cannot directly reset your Job Nimbus data, but if you would like your
              Job Nimbus contact data to be reset, contact your Job Nimbus admin and we will work together to
              restore your backed up data.
            </p>
          </li>
        </ul>
      </Modal.Body>
      <Modal.Footer>
        <Row>
          <Col xs={6} md={6}>
            <Button
              bsStyle='success'
              bsSize='small'
              block
              onClick={handleClickKeepCurrentData}
              >
              Keep Current data
            </Button>
          </Col>
          <Col xs={6} md={6}>
            <Button
              bsStyle='success'
              bsSize='small'
              block
              onClick={handleClickResetData}
              >
              Reset Data
            </Button>
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  );
}

export default JNCancellationOpts;



// WEBPACK FOOTER //
// ./src/browser/components/settings/integrations/jobnimbus/jn-cancellation-opts.js